/**
 * Client-side legacy fragment filter migration script
 * Rewrites legacy URL fragments (e.g. #/filter:vendor:CCM, #/sort:ss_pct_off:desc)
 * to canonical Shopify query parameters (e.g. ?filter.v.vendor=CCM&sort_by=...)
 */
(function () {
  if (!window.location.hash || !window.location.hash.startsWith('#/')) return;

  var hash = window.location.hash.substring(2);
  var parts = hash.split('/');
  var params = new URLSearchParams(window.location.search);
  var modified = false;

  parts.forEach(function (part) {
    if (part.startsWith('filter:')) {
      var filterPair = part.substring(7).split(':');
      if (filterPair.length >= 2) {
        var key = filterPair[0];
        var val = filterPair.slice(1).join(':');

        if (key === 'vendor') {
          params.set('filter.v.vendor', val);
          modified = true;
        } else if (key === 'availability') {
          params.set('filter.v.availability', val);
          modified = true;
        } else if (key.length > 0) {
          params.set('filter.p.m.shs.' + key, val);
          modified = true;
        }
      }
    } else if (part.startsWith('sort:')) {
      var sortPair = part.substring(5).split(':');
      if (sortPair.length >= 1) {
        params.set('sort_by', sortPair[0]);
        modified = true;
      }
    }
  });

  if (modified) {
    var newUrl = window.location.pathname + '?' + params.toString();
    window.location.replace(newUrl);
  }
})();
